import { faStar as starSolid, faTrash, faCircleArrowUp } from "@fortawesome/free-solid-svg-icons"
import { faStar as starRegular } from "@fortawesome/free-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IBankAccount } from "interfaces/IBankAccount"
import { Row, Col, Form } from "react-bootstrap"

/**
 * Custom props for the bank account component
 */
interface Props {
    /**
     * The bank account information
     */
    bankAccount: IBankAccount | undefined;
    /**
     * Is default flag to keep the trash button from appearing 
     */
    isDefault?: boolean;
    /**
     * flag to load an icon to recover a removed bank account
     */
    isRecover?: boolean;
    /**
     * Container custom class
     */
    containerClass?: string;
    /**
     * set the default bank account
     */
    setDefaultAccount?: (accountId: number) => void;
    /**
     * set the default bank account
     */
    changeStatus?: (accountId: number) => void;
}

/**
 * Component that renders a single row of a bank account info
 */
export const BankAccount = ({
    bankAccount,
    isDefault,
    isRecover = false,
    containerClass,
    setDefaultAccount = () => { },
    changeStatus = () => { }
}: Props) => {

    /**
     * on favorite icon click function
     */
    const onFavorite = () => {
        if (!bankAccount)
            return;
        setDefaultAccount(bankAccount.id);
    }

    /**
     * on remove icon click function
     */
    const onChangeStatus = () => {
        if (!bankAccount)
            return;
        changeStatus(bankAccount.id);
    }

    return (
        <div className={containerClass}>
            {bankAccount ?
                <Row>
                    <Col xs={4}>
                        <Form.Control
                            className="me-2"
                            type="text"
                            value={bankAccount.card_number || bankAccount.account_number || bankAccount.clabe}
                            readOnly={true}
                        />
                    </Col>
                    <Col xs={2}>
                        <Form.Control
                            className="me-2"
                            type="text"
                            value={bankAccount.bank_name}
                            readOnly={true}
                        />
                    </Col>
                    <Col xs={5}>
                        <Form.Control
                            type="text"
                            value={bankAccount.account_holder}
                            readOnly={true}
                        />
                    </Col>
                    <Col xs={1} className="d-flex justify-content-between align-items-center ">
                        {!isRecover &&
                            <>
                                <FontAwesomeIcon 
                                    onClick={onFavorite} 
                                    icon={isDefault ? starSolid : starRegular} 
                                    className={`justify-self-start ${isDefault ? "" : "cursor--pointer"}`} 
                                    color="#997404" 
                                />
                                {!isDefault && <FontAwesomeIcon onClick={onChangeStatus} icon={faTrash} className="justify-self-end cursor--pointer" color="#997404" />}
                            </>
                        }
                        {isRecover && 
                            <FontAwesomeIcon 
                                onClick={onChangeStatus} 
                                icon={faCircleArrowUp} 
                                className="justify-self-start cursor--pointer"
                                color="#997404" 
                                fontSize={25}
                            />
                        }
                    </Col>
                </Row>
                :
                <div />
            }
        </div>
    )
}
